import { AccountingCodeSectionProps } from '../../types';
import { CheckoutSection } from './CheckoutSection';

/**
 * Accounting code selection section for checkout.
 * Allows users to select an optional accounting code for their order.
 * If displayOnlyValue is provided and no accountingCodes are available, shows the value as read-only text.
 */
export function AccountingCodeSection({
  accountingCodes,
  selectedAccountingCode,
  onAccountingCodeChange,
  displayOnlyValue,
}: AccountingCodeSectionProps) {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const code = accountingCodes?.find((c) => c.id === Number(e.target.value));
    onAccountingCodeChange(code);
  };

  // If no accounting codes are available but we have a display-only value, show it as text
  if ((!accountingCodes || accountingCodes.length === 0) && displayOnlyValue) {
    return (
      <CheckoutSection title="Accounting Code">
        <div className="w-full border border-gray-300 rounded-lg px-4 py-2.5 bg-gray-50 text-gray-900">
          {displayOnlyValue}
        </div>
      </CheckoutSection>
    );
  }

  // If we have no accounting codes and no display value, don't render anything
  if (!accountingCodes || accountingCodes.length === 0) {
    return null;
  }

  return (
    <CheckoutSection title="Accounting Code">
      <select
        className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
        value={selectedAccountingCode?.id || ''}
        onChange={handleChange}
      >
        <option value="">Select an accounting code (optional)</option>
        {accountingCodes
          .filter((c) => c.active)
          .map((code) => (
            <option key={code.id} value={code.id}>
              {code.name}
            </option>
          ))}
      </select>
    </CheckoutSection>
  );
}
